import React, { useState, useEffect } from 'react';
import { FormInput, Loader, ErrorSuccessModal } from '../../components/commons';
import { ChangePasswordPayloadType } from '../../commonTypes/authTypes'
import { RootState } from '../../redux/rootReducers';
import { checkHasLowerLetter, checkHasNumber, checkHasSpecial, checkHasUpperLetter, setCookie } from '../../utils/commonFunctions'
import { connect } from 'react-redux';
import { updatePasswordAction } from '../../redux/auth'
import { resetAuthError, resetAuthSuccess, resetSession } from '../../redux/auth';

import { convertPasswordToHash } from '../../utils/commonFunctions';
import PasswordValidationCard from '../../components/commons/PasswordValidationCard/PasswordValidationCard';

type Props = {
    dispatchUpdatePasswordAction: (data: ChangePasswordPayloadType) => void;
    token: string | null;
    success: number | null;
    fetching: boolean;
    statusCode: number | null;
    error: string | null;
    dispatchResetAuthError: () => void;
    dispatchResetAuthSuccess: () => void;
    dispatchResetSession: () => void;
}

type PasswordResultType = {
  least: boolean;
  uppercase: boolean;
  special: boolean;
  lower: boolean;
  number:boolean
};

const ChangePassword = ({
    dispatchUpdatePasswordAction,
    dispatchResetSession,
    token,
    success,
    fetching,
    error,
    statusCode,
    dispatchResetAuthError,
    dispatchResetAuthSuccess
}: Props) => {

    const [passwordPopUpShow, setPasswordPopUpshow] = useState(false);

    const [profileDetailsError, setProfileDetailsError] = useState({
    newPasswordError: "",
    newPasswordAgainError: "",
  });
    
    useEffect(() => {
        dispatchResetAuthError();
        dispatchResetAuthSuccess();
    }, []);

    const [state, setState] = useState({
        currentPassword: '',
        resetPassword: '',
        confirmPassword: '',
    });
    const [passwordResult, setPasswordResult] = useState<PasswordResultType>({
    least: false,
    uppercase: false,
    special: false,
    lower: false,
    number: false,
  });

    const [errorText, setError] = useState('');

    const handleChange = (event: any) => {
        setError('')
        if (event.target.name === "resetPassword") {
        setPasswordPopUpshow(true);
    if (event.target.value && setPasswordResult) {
      let specialCharacterValue = checkHasSpecial(event.target.value);
      let uppercaseLetterValue = checkHasUpperLetter(event.target.value);
        let lowercaseLetterValue = checkHasLowerLetter(event.target.value);
        let numbercaseLetterValue = checkHasNumber(event.target.value);
        
      if (event.target.value.length >= 8) {
        setPasswordResult((prv: any) => ({
          ...prv,
          least: true,
        }));
      }

      if (lowercaseLetterValue) {
        setPasswordResult((prv: any) => ({
          ...prv,
          lower: true,
        }));
      }

      if (specialCharacterValue) {
        setPasswordResult((prv: any) => ({
          ...prv,
          special: true,
        }));
      }
      if (uppercaseLetterValue) {
        setPasswordResult((prv: any) => ({
          ...prv,
          uppercase: true,
        }));
      }
      if (numbercaseLetterValue) {
        setPasswordResult((prv: any) => ({
          ...prv,
          number: true,
        }));
      }
      if (!numbercaseLetterValue) {
        setPasswordResult((prv: any) => ({
          ...prv,
          number: false,
        }));
      }

      if (!uppercaseLetterValue) {
        setPasswordResult((prv: any) => ({
          ...prv,
          uppercase: false,
        }));
      }

      if (!specialCharacterValue) {
        setPasswordResult((prv: any) => ({
          ...prv,
          special: false,
        }));
      }
      if (!lowercaseLetterValue) {
        setPasswordResult((prv: any) => ({
          ...prv,
          lower: false,
        }));
      }
      if (event.target.value.length < 8) {
        setPasswordResult((prv: any) => ({
          ...prv,
          least: false,
        }));
      }
    } else {
      setPasswordResult ({
        least: false,
        uppercase: false,
        special: false,
        lower: false,
        number:false
      });
    }
    }
        setState({ ...state, [event.target.name]: event.target.value })
    }

    const validatePaddword = () => {
        if (state.resetPassword.length < 8) {
            setError('Password should be minmum of 8 charactes')
            return
        }
        else if (
        state?.currentPassword?.length > 0 &&
        Object.values(passwordResult).includes(false)
         ) { 
             setError('Password must meet requirements')
         }
        
        else if (state.resetPassword !== state.confirmPassword) {
            setError('New password and confirm password should be same')
            return
        }
        else {
            setError('')
            handlePasswordChange()
        }
    }

    const handlePasswordChange = async () => {
        let enCurrentPassword = await convertPasswordToHash(state.currentPassword);
        let enResetPassword = await convertPasswordToHash(state.resetPassword);
        let enConfirmPassword = await convertPasswordToHash(state.confirmPassword);

        let data = {
            currentPassword: enCurrentPassword,
            resetPassword: enResetPassword,
            confirmPassword: enConfirmPassword,
            token
        }

        dispatchResetAuthError();
        dispatchResetAuthSuccess();
        dispatchUpdatePasswordAction(data)

    }

    const handleErrorModal = () => {
        if (success === 0) {
            if (statusCode === 401) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message={error}
                        buttonText="Logout"
                        onPress={() => dispatchResetSession()}
                        statusCode={statusCode}
                    />
                )
            } else if ((!!error && statusCode !== 401)) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message={error}
                        buttonText="OK"
                        onPress={() => {
                            dispatchResetAuthError();
                        }}
                    />
                )
            }
        }

        if (success === 1) {
            return (
                <ErrorSuccessModal
                    type="success"
                    isOpen={success === 1}
                    title="Success"
                    message="Password Updated Successfully. Please Login Again."
                    buttonText="Logout"
                    onPress={() => {
                        dispatchResetSession();
                    }}
                    statusCode={statusCode}
                />
            )
        }

        return false;
    }

    return (

        <div className="col-6  ml-auto mt-5 mb-3" style={{ borderRadius: "8px" }}>
            <FormInput
                handleChange={handleChange}
                placeholder="Enter Old Password"
                value={state.currentPassword}
                name='currentPassword'
                type='password'
                autoFocus
            />
            <div className=" position-relative">

            <FormInput
                handleChange={handleChange}
                placeholder="Enter New Password"
                type='password'
                value={state.resetPassword}
                name='resetPassword'
                />
            {state.resetPassword && state.resetPassword.length &&
            passwordPopUpShow && passwordResult &&
            Object.values(passwordResult).includes(false) ? (
                <PasswordValidationCard
                className={"tooltext-right"}
                triangleClassName={"triangle-right"}
                isLeast={passwordResult?.least}
                isUpperCase={passwordResult?.uppercase}
                isLowerCase={passwordResult?.lower}
                isSpecial={passwordResult?.special}
                isNumber={passwordResult?.number}
                />
                ) : (
                    ""
                    )}
                    </div>

            <FormInput
                handleChange={handleChange}
                placeholder="Confirm New Password"
                value={state.confirmPassword}
                type='password'
                name='confirmPassword'
            />
            <p className='error'>{errorText ? errorText : ''}</p>
            <button
                className="btn btn-primary w-100 mt-2"
                onClick={validatePaddword}
                disabled={(state.currentPassword && state.resetPassword && state.confirmPassword&& !Object.values(passwordResult).includes(false)? false : true)}
            >
                Submit
            </button>
            {fetching && <Loader />}
            {handleErrorModal()}
        </div>


    )
}


const mapStateToProps = (state: RootState) => ({
    success: state.auth.success,
    fetching: state.auth.fetching,
    error: state.auth.error,
    token: state.auth.token,
    statusCode: state.auth.statusCode
})

const mapDispatchToProps = (dispatch: any) => ({
    dispatchUpdatePasswordAction: (data: ChangePasswordPayloadType) => dispatch(updatePasswordAction(data)),
    dispatchResetAuthError: () => dispatch(resetAuthError()),
    dispatchResetAuthSuccess: () => dispatch(resetAuthSuccess()),
    dispatchResetSession: () => dispatch(resetSession())
})


export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword)